export enum AuditScreen {
  AircraftProfile = 'Aircraft Profile',
  AirportProfile = 'Airport Profile',
  CompanyProfile = 'Company Profile',
  PersonProfile = 'Person Profile',
  TrainingRequirementProfile = 'Training Requirement Profile',
  AircraftEvent = 'Aircraft Event',
  StaffEvent = 'Staff Event',
  DeletedTrips = 'Deleted Trips',
  ScheduledTrip = 'Scheduled Trip',
  TripManager = 'Trip Manager',
  PostedFlight = 'Posted Flight',
  SimulatedFlight = 'Simulated Flight',
  Expense = 'Expense',
  DeletedExpenses = 'Deleted Expenses',
  FleetOverview = 'Fleet Overview',
  UserManagement = 'User Management',
  RoleManagement = 'Role Management'
}
